import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sendEvent } from '@chegg/rio2-web-client';
/**
 * Util to log event in Rio2.0
 * @param eventType
 * @param eventData
 * @param updateView
 * @param isRedirectInSameTabEvent boolean
 */
export var sendEventRio2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var eventType, eventData, updateView, isRedirectInSameTabEvent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          eventType = _ref.eventType, eventData = _ref.eventData, updateView = _ref.updateView, isRedirectInSameTabEvent = _ref.isRedirectInSameTabEvent;
          _context.next = 3;
          return sendEvent(eventType, eventData, updateView, isRedirectInSameTabEvent);
        case 3:
          return _context.abrupt("return", _context.sent);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sendEventRio2(_x) {
    return _ref2.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/rsw2.0.js
// module id = 4138
// module chunks = 11